<div class="shipping-order-item-update-modal" *ngIf="info">
  <div class="shipping-order-item-update-modal__top">
    <div class="shipping-order-item-update-modal__top__product">
      <img
        [src]="info.productVariantImage || 'assets/images/no_img_available.jpg'"
        [alt]="info.productVariantName"
      />
      <span>
        <a
          [routerLink]="
            '/products/catalog/product-variant/' + info.productVariantId
          "
          class="data-link"
        >
          {{ info.productVariantName }}
        </a>
      </span>
      <span><strong>BrandEquity:</strong> {{ info.brandEquity || 0 }}</span>
      <span>
        <strong>Preço custo:</strong>
        {{ info.costPrice || 0 | currency: 'BRL' }}
      </span>
      <span>
        <strong>Preço venda:</strong>
        {{ info.salePrice || 0 | currency: 'BRL' }}
      </span>
      <span>
        <strong>Preço nota:</strong>
        {{ info.invoicePrice || 0 | currency: 'BRL' }}
      </span>
      <span>
        <strong>Peso:</strong> {{ info.weight || 0 | number: '1.0-2' }} g
      </span>
      <span>
        <strong>Categoria:</strong> {{ info.category || 'Sem categoria' }}
      </span>
      <span *ngIf="info.rating">
        <strong>Rating:</strong> {{ info.rating | number: '1.0-2' }}
      </span>
    </div>
    <i class="pi pi-arrow-right"></i>
    <div class="shipping-order-item-update-modal__top__product">
      <img
        [src]="
          info.productVariantImageNew || 'assets/images/no_img_available.jpg'
        "
        [alt]="info.productVariantNameNew"
      />
      <span>
        <a
          [routerLink]="
            '/products/catalog/product-variant/' + info.productVariantIdNew
          "
          class="data-link"
        >
          {{ info.productVariantNameNew }}
        </a>
      </span>
      <span>
        <strong>BrandEquity:</strong> {{ info.brandEquityNew || 0 }}
        <span
          *ngIf="info.brandEquityNew !== info.brandEquity"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.brandEquityNew - info.brandEquity < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.brandEquityNew - info.brandEquity > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.brandEquityNew - info.brandEquity > 0,
              'pi-arrow-down': info.brandEquityNew - info.brandEquity < 0
            }"
          ></i>
          {{ info.brandEquityNew - info.brandEquity | number: '1.0-2' }}
        </span>
      </span>
      <span>
        <strong>Preço custo:</strong>
        {{ info.costPriceNew || 0 | currency: 'BRL' }}
        <span
          *ngIf="info.costPriceNew !== info.costPrice"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.costPriceNew - info.costPrice < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.costPriceNew - info.costPrice > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.costPriceNew - info.costPrice > 0,
              'pi-arrow-down': info.costPriceNew - info.costPrice < 0
            }"
          ></i>
          {{ info.costPriceNew - info.costPrice | currency: 'BRL' }}
        </span>
      </span>
      <span>
        <strong>Preço venda:</strong>
        {{ info.salePriceNew || 0 | currency: 'BRL' }}
        <span
          *ngIf="info.salePriceNew !== info.salePrice"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.salePriceNew - info.salePrice < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.salePriceNew - info.salePrice > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.salePriceNew - info.salePrice > 0,
              'pi-arrow-down': info.salePriceNew - info.salePrice < 0
            }"
          ></i>
          {{ info.salePriceNew - info.salePrice | currency: 'BRL' }}
        </span>
      </span>
      <span>
        <strong>Preço nota:</strong>
        {{ info.invoicePriceNew || 0 | currency: 'BRL' }}
        <span
          *ngIf="info.invoicePriceNew !== info.invoicePrice"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.invoicePriceNew - info.invoicePrice < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.invoicePriceNew - info.invoicePrice > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.invoicePriceNew - info.invoicePrice > 0,
              'pi-arrow-down': info.invoicePriceNew - info.invoicePrice < 0
            }"
          ></i>
          {{ info.invoicePriceNew - info.invoicePrice | currency: 'BRL' }}
        </span>
      </span>
      <span>
        <strong>Peso:</strong> {{ info.weightNew || 0 | number: '1.0-2' }} g
        <span
          *ngIf="info.weightNew !== info.weight"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.weightNew - info.weight < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.weightNew - info.weight > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.weightNew - info.weight > 0,
              'pi-arrow-down': info.weightNew - info.weight < 0
            }"
          ></i>
          {{ info.weightNew - info.weight | number: '1.0-2' }} g
        </span>
      </span>
      <span>
        <strong>Categoria:</strong> {{ info.categoryNew || 'Sem categoria' }}
      </span>
      <span *ngIf="info.ratingNew">
        <strong>Rating:</strong> {{ info.ratingNew | number: '1.0-2' }}
        <span
          *ngIf="info.ratingNew !== info.rating"
          [class.shipping-order-item-update-modal__top__product__danger]="
            info.ratingNew - (info.rating || 0) < 0
          "
          [class.shipping-order-item-update-modal__top__product__success]="
            info.ratingNew - (info.rating || 0) > 0
          "
        >
          <i
            class="pi"
            [ngClass]="{
              'pi-arrow-up': info.ratingNew - (info.rating || 0) > 0,
              'pi-arrow-down': info.ratingNew - (info.rating || 0) < 0
            }"
          ></i>
          {{ info.ratingNew - (info.rating || 0) | number: '1.0-2' }}
        </span>
      </span>
    </div>
  </div>
  <div class="shipping-order-item-update-modal__warnings" *ngIf="hasWarnings">
    <span
      class="shipping-order-item-update-modal__warnings__warn"
      *ngIf="info.baldConflict"
    >
      * A opção "Estou careca" está assinalada no perfil da assinante
    </span>
    <span
      class="shipping-order-item-update-modal__warnings__warn"
      *ngIf="info.received"
    >
      * Produto já recebido pela assinante
    </span>
  </div>
  <div class="shipping-order-item-update-modal__bottom">
    <p-button
      label="Escolher outro produto"
      (onClick)="ref.close(null)"
      styleClass="p-button-warning"
    />
    <p-button
      label="Confirmar"
      (onClick)="submit()"
      styleClass="p-button-primary"
    />
  </div>
</div>
